<template>
  <section class="section" v-if="offers && offers.length > 0">
    <div class="container">
      <h2 class="title is-size-3 has-text-centered is-size-4-mobile">{{ title }}</h2>
      <div class="columns is-multiline is-variable is-5 is-block-print">
        <div v-for="offer in offers" :key="offer.id" class="column is-half-tablet is-one-third-desktop is-flex avoid-break-inside">
          <OfferElement :product="offer" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import OfferElement from '@/components/OfferElement'
export default {
  name: 'OfferBlock',
  components: {
    OfferElement,
  },
  props: {
    title: String,
    offers: Array,
  },
}
</script>

<style scoped lang="scss"></style>
